/**
 * @architecture-header 1
 * @layer shared
 * @domain workspace-state
 * @responsibility Coordinate reset-only callbacks for context-scoped transient UI stores.
 * @state-owner module-scoped reset callback registry
 * @allowed-imports TypeScript standard library
 * @forbidden API entities; roles; permissions; tokens; React; localStorage
 * @public-api auth context teardown and module UI stores
 * @side-effects invokes registered in-memory reset callbacks
 * @tests module-contracts.test.ts
 */

const transientResets = new Map<string, () => void>();

export function registerWorkspaceTransientReset(key: string, reset: () => void) {
  transientResets.set(key, reset);
}

export function resetWorkspaceTransientState() {
  for (const reset of transientResets.values()) reset();
}
